import styled from 'styled-components';

const GridCol = styled.div`
  padding-right: 15px;
  padding-left: 15px;
  box-sizing: border-box;
`;

export default GridCol;
